import { createRef, useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import utilsUsers from "../Connections/_Utils/utilsUsers";
import {
    AddCircleOutline, AlignHorizontalLeftRounded, ArrowCircleRightSharp,
    ArrowCircleUp, ContactlessOutlined, HighlightOff, RemoveCircleOutline
} from "@mui/icons-material";

import styles from './FinishedOrder.module.css';

import pageStylePops from './pageStylePops.module.css';


import utilsOrders from "../Connections/_Utils/utilsOrders";

import Scroll from 'react-scroll';

import { UserContext } from "../Contexts/User_Context";
import { Checkbox } from "@mui/material";
import { MasterContext } from "../Contexts/Master_Context";
import { MobiOrNotContext } from "../Contexts/MobiOrNot_Context";
import MyFunctions from "../Functions/MyFunctions";
import MyDateTime from "../ForAllComponents/MyDateTime";
import { TheOrderContext } from "../Contexts/TheOrder_Context";
import ConnUrls from "../Connections/ConnectURL";
import { SpecialUserContext } from "../Contexts/SpecialUser_Context";

var scroller = Scroll.scroller;

const FinishedOrder = (props) => {



    const [master, setMaster] = useContext(MasterContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [user, setUser, UserEffectFunction] = useContext(UserContext);
    const [specialUser, setSpecialUser] = useContext(SpecialUserContext);
    const { theOrder, setTheOrder, addToTheOrder, updateTheOrd } = useContext(TheOrderContext);
    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : styles);

    const [remarks, setRemarks] = useState("");


    const navigate = useNavigate();

    useEffect(() => {

    }, [])



    // const setTheRemarks = (remarksAsks) => {
    //     setRemarks(remarksAsks);
    // }

    const continueIt = () => {
        let tempOrd = { ...props.theOrder };
        tempOrd.user = specialUser && Object.keys(specialUser).length > 0
            ? { ...specialUser, parentUser: user }
            : user


        props.theFunction(tempOrd, true);
    }

    const gobackTo = (popName) => {

        props.gobackTo(popName, props.theOrder);
    }



    let delPrc = 0;


    return (
        <div className={"finishOrdrPage spaceMargeTop_10 inColorBlack"}>
            <div>
                <div className="grayFrame">
                    <div className="bold big spacePaddingBottom_5">פרטי הלקוח</div>
                    <div className={"dottedLineSpacer catal"}></div>
                    <div className="fullRow spaceMargeTop_5">
                        <div className="onRight">
                            <span className="bold">שם מלא: </span>
                            {!specialUser || (Object.keys(specialUser).length === 0) ?
                                <span>{`${user.firstName} ${user.lastName}`}</span>
                                :
                                <span>{`${specialUser.firstName} ${specialUser.lastName}`}</span>
                            }
                        </div>
                    </div>
                    <div className="fullRow spaceMargeTop_5">
                        <div className="onRight">
                            <span className="bold">טלפון: </span>
                            {!specialUser || (Object.keys(specialUser).length === 0) ?
                                <span className={""}><a className={"noDecoration"} href={`tel:${user.phone}`}>{user.phone}</a></span>
                                :
                                <span className={""}><a className={"noDecoration"} href={`tel:${specialUser.phone}`}>{specialUser.phone}</a></span>
                            }

                        </div>
                    </div>

                    {!specialUser || (Object.keys(specialUser).length === 0) ? user.email &&
                        <div className="fullRow spaceMargeTop_5">
                            <div className="onRight">
                                <span className="bold">אימייל: </span>
                                <span className={""}><a className={"noDecoration"} href={`mailto:${user.email}`}>{user.email}</a></span>
                            </div>
                        </div>
                        :
                        <div className="fullRow spaceMargeTop_5">
                            <div className="onRight">
                                <span className="bold">אימייל: </span>
                                <span className={""}><a className={"noDecoration"} href={`mailto:${specialUser.email}`}>{specialUser.email}</a></span>
                            </div>
                        </div>
                    }

                </div>
                <div className="grayFrame">
                    <div className="fullRow">
                        <div className="bold big onRight">מועד הגעה</div>
                        <div className={`${styles.btnSmall} bold pointing onLeft`}
                            onClick={() => gobackTo("selDateTime")}>
                            שנה
                        </div>
                    </div>
                    <div className={"dottedLineSpacer catal"}></div>
                    <div className="fullRow spaceMargeTop_5">
                        <div className="onRight">
                            <span className="bold">תאריך: </span>
                            {/* <span>{theOrder.dateToDeliver}</span> */}
                            <span>{props.theOrder.dateToDeliver.split(" ")[0]}</span>
                        </div>
                        <div className="onRight spaceMargeRight_10">
                            <span className="bold">שעה: </span>
                            <span>{props.theOrder.dateToDeliver.split(" ")[1]}</span>
                        </div>
                    </div>
                </div>
                <div className="grayFrame">
                    <div className="fullRow">
                        {props.orderDetails.OrderType === "Deliver" ?
                            <div className="bold big onRight">פרטי המשלוח</div> :
                            <div className="bold big onRight">איסוף עצמי</div>
                        }
                        <div className={`${styles.btnSmall} bold pointing onLeft`}
                            onClick={() => gobackTo("theSeleAddres")}>
                            שנה
                        </div>
                    </div>
                    {
                        (props.orderDetails.OrderType === "Deliver") &&
                        <>
                            <div className={"dottedLineSpacer catal"}></div>
                            <div><span className="bold">עיר: </span>
                                <span>{props.orderDetails.theSeleAddres.city}</span>
                            </div>
                            <div className="fullRow">
                                <div className="onRight">
                                    <span className="bold">רחוב: </span>
                                    <span>{props.orderDetails.theSeleAddres.street}</span>
                                </div>
                                <div className="onRight spaceMargeRight_10">
                                    <span className="bold">מספר: </span>
                                    <span>{props.orderDetails.theSeleAddres.num}</span>
                                </div>
                            </div>

                            <div className="fullRow">
                                {props.orderDetails.theSeleAddres.appartment &&
                                    props.orderDetails.theSeleAddres.appartment !== "" &&
                                    <div className="onRight">
                                        <span className="bold">דירה: </span>
                                        <span>{props.orderDetails.theSeleAddres.appartment}</span>
                                    </div>
                                }
                                {props.orderDetails.theSeleAddres.ent &&
                                    props.orderDetails.theSeleAddres.ent !== "" &&
                                    <div className="onRight spaceMargeRight_10">
                                        <span className="bold">כניסה: </span>
                                        <span>{props.orderDetails.theSeleAddres.ent}</span>
                                    </div>
                                }
                            </div>
                            <div className="fullRow">
                                {props.orderDetails.theSeleAddres.flor &&
                                    props.orderDetails.theSeleAddres.flor !== "" &&
                                    <div className="onRight">
                                        <span className="bold">קומה: </span>
                                        <span>{props.orderDetails.theSeleAddres.flor}</span>
                                    </div>
                                }
                                {props.orderDetails.theSeleAddres.remarks &&
                                    props.orderDetails.theSeleAddres.remarks !== "" &&
                                    <div className="onRight spaceMargeRight_10">
                                        <span className="bold">הערות: </span>
                                        <span>{props.orderDetails.theSeleAddres.remarks}</span>
                                    </div>
                                }
                            </div>
                        </>
                    }
                </div>

                <div className="grayFrame">
                    <div className="fullRow">
                        <div className="fullRow">
                            <div className="bold big onRight">הערות נוספות</div>
                            <div className={`${styles.btnSmall} bold pointing onLeft`}
                                onClick={() => gobackTo("theRequest")}>
                                {props.orderDetails.theRequest ? "שנה" : "הוסף"}
                            </div>
                        </div>
                        {
                            props.orderDetails.theRequest &&
                            <>
                                <div className={"dottedLineSpacer catal"}></div>
                                <div>{props.orderDetails.theRequest}</div>
                            </>
                        }
                    </div>

                </div>
                <div className="grayFrame">
                    <div className="fullRow">
                        <div className="fullRow">
                            <div className="bold big spacePaddingBottom_5">תוכן ההזמנה</div>
                        </div>
                        <div className={"dottedLineSpacer catal"}></div>

                        <div>

                            {props.theOrder.items
                                .filter((item) => item) // חיפוש פריט מתאים ב-theOrder
                                .map((orderItem, orderItemIndx) => {
                                    if (props.orderDetails.OrderType === "Deliver") {
                                        delPrc = master.cityesToDeliver.filter(itm => itm.cityName === props.orderDetails.theSeleAddres.city)[0];
                                    }
                                    return (
                                        <div key={orderItemIndx} className={`${currnetStyle.orderItemWrap}`} >
                                            <div className={"fullRow"} >
                                                <div className={`${currnetStyle.imgSide}`}>
                                                    <div className={`${currnetStyle.prodImg}`}>
                                                        <img src={`${ConnUrls.servMediasUrl}${orderItem.prodImageUrl}`} alt={orderItem.prodName || ""} />
                                                    </div>
                                                </div>
                                                <div className={`${currnetStyle.detailsSide}`}>

                                                    <span className={"fullRow  big bold"}>{orderItem.prodName}</span>

                                                    {orderItem.prodOptions?.map((optionGroup, index) => {
                                                        const selectedOptions = optionGroup.options.filter((opt) => opt.selected); // Get selected options                                                          
                                                        return selectedOptions.length > 0 ? (
                                                            <div key={index}>
                                                                <span className={"fullRow regular"}>{optionGroup.optionName}:</span>
                                                                <div>
                                                                    {selectedOptions.map((selectedOpt, optIndex) => (
                                                                        <div key={optIndex}>
                                                                            <div className={"fullRow small"}>
                                                                                {selectedOpt.servType}
                                                                                {selectedOpt.mount > 1 ? ` כמות: ${(selectedOpt.mount)}` : ""}
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                    {orderItem.remarks && orderItem.remarks !== "" &&
                                                        <div className={" regular bold"}>הערות למנה: {orderItem.remarks} </div>
                                                    }
                                                    <div className={"fullRow"}>
                                                        <div className={"regular bold"}>כמות: {orderItem.mount}</div>
                                                    </div>
                                                    <div className={"fullRow"}>
                                                        <span className={"regular bold onLeft"}>
                                                            {
                                                                MyFunctions.getItemTotalPrice(orderItem)

                                                            } ₪
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={"dottedLineSpacer"}></div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
                <div className={"fullRow"}>
                    <div className={`${styles.totalHead} bold onRight`}>סכום ההזמנה</div>
                    <div className={`${styles.totalHead} bold onLeft`}>{MyFunctions.getOrderPrice(props.theOrder)} ₪ </div>
                </div>
                {props.orderDetails.OrderType === "Deliver" &&
                    <div className={"fullRow"}>
                        <div className={`${styles.totalHead} bold onRight`}>משלוח ({delPrc.cityName})</div>
                        <div className={`${styles.totalHead} bold onLeft`}>
                            {delPrc.delivPrice} ₪
                        </div>
                    </div>
                }
                <div className={"fullRow"}>
                    <div className={`${styles.totalHead} bold onRight`}>סה"כ</div>
                    <div className={`${styles.totalHead} bold onLeft`}>{MyFunctions.getOrderTotalPrice(props.theOrder, delPrc)} ₪ </div>
                </div>

                <div className={`${styles.totalHead} bold centerText`}>כל המחירים בשקלים וכוללים מע"מ</div>

            </div>
            <div className={pageStylePops.contWrap}>
                <div className={pageStylePops.btnGo}>
                    <button className={`${pageStylePops.contactGo} pointing`} value="המשך"
                        onClick={() => continueIt()} >המשך לתשלום</button>
                </div>
            </div>
        </div >


    )

}

export default FinishedOrder